import { useCallback, useEffect, useRef, useState } from 'react';

const BASE = '/api';

export async function apiGet(path, params) {
  const qs = params ? '?' + new URLSearchParams(
    Object.entries(params).filter(([, v]) => v !== '' && v != null)) : '';
  const res = await fetch(`${BASE}${path}${qs}`);
  if (!res.ok) throw new Error(`${path}: HTTP ${res.status}`);
  return res.json();
}

export async function apiPost(path, body) {
  const res = await fetch(`${BASE}${path}`, {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error(`${path}: HTTP ${res.status}`);
  return res.json();
}

/** 周期轮询 hook。intervalMs 默认 8s；页面不可见时暂停。 */
export function usePolling(path, params, intervalMs = 8000) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const timer = useRef(null);
  const paramsKey = JSON.stringify(params || {});

  const refresh = useCallback(async (silent = true) => {
    if (!silent) setLoading(true);
    try {
      const d = await apiGet(path, JSON.parse(paramsKey));
      setData(d);
      setError(null);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }, [path, paramsKey]);

  useEffect(() => {
    let stopped = false;
    const tick = () => {
      if (stopped || document.hidden) return;
      refresh(true);
    };
    refresh(false);
    timer.current = setInterval(tick, intervalMs);
    const onVis = () => { if (!document.hidden) refresh(true); };
    document.addEventListener('visibilitychange', onVis);
    return () => {
      stopped = true;
      clearInterval(timer.current);
      document.removeEventListener('visibilitychange', onVis);
    };
  }, [refresh, intervalMs]);

  return {data, error, loading, refresh};
}
